import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { fadeUp } from '../utils/motion';
import { noetivraAvailabilityLabel } from '../data/siteContent';
import { demoCenterPath } from '../data/demoCenter';
import { FutureUses } from './layout/FutureUses';
const modules = [{
  name: 'CJI',
  desc: 'Structured reasoning and judgment assessment.'
}, {
  name: 'NCJI Youth',
  desc: 'Developmental support for early education.'
}, {
  name: 'NCJI Pathways',
  desc: 'Workforce readiness and opportunity alignment.'
}, {
  name: 'NCJI Civic',
  desc: 'Community resilience and manipulation resistance.'
}, {
  name: 'NCJI Service',
  desc: 'Integrity and systems reasoning for the public sector.'
}, {
  name: 'NCJI Executive',
  desc: 'Crisis reasoning and governance readiness.'
}, {
  name: 'NCJI Atlas',
  desc: 'Aggregate capability mapping for institutions.'
}];
export function ProductEcosystem() {
  return <section className="py-20 lg:py-28 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto border-t border-line" data-id="element-1858" data-mp="30musrqu0ke2a">
      <div className="mb-12" data-id="element-1859" data-mp="13mhblk0vxy7f">
        <span className="text-xs font-semibold text-navy-light uppercase tracking-[0.2em] mb-4 block" data-id="element-1860" data-mp="ynwjk7vseku2">
          Assessment &amp; Development Modules
        </span>
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-ink-dark" data-id="element-1861" data-mp="tn8isuhrapmn">
          Within the Human Capability Framework
        </h2>
        <p className="mt-4 text-lg text-ink-muted leading-relaxed max-w-3xl" data-id="element-1862" data-mp="knv6zv65toyr">
          The framework combines assessment methods, development pathways, and
          supporting services. These are proposed modules within CJI and NCJI. Each would
          require validation for its intended use before consequential
          application.
        </p>
      </div>

      <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-id="element-1863" data-mp="61209eaphri6">
        {modules.map(module => <li key={module.name} className="bg-surface-card p-6 rounded-lg border border-line flex flex-col h-full" data-id="element-1864" data-mp="3t3yd3whmj5kz">
            <h3 className="text-lg font-heading font-bold text-navy mb-2" data-id="element-1865" data-mp="3jft3u7900qcr">{module.name}</h3>
            <p className="text-sm text-ink-muted" data-id="element-1866" data-mp="3nho1n1rq0lls">{module.desc}</p>
          </li>)}
      </ul>

      <motion.div {...fadeUp} className="mt-16 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16 border-t border-line pt-12" data-id="element-1867" data-mp="39iogi43f2oud">
        <div className="lg:col-span-5" data-id="element-1868" data-mp="3ehhvk0ycqnwn">
          <p className="text-sm font-medium text-teal mb-2" data-id="element-1869" data-mp="61oenl03zaf2">Noetivra · {noetivraAvailabilityLabel}</p>
          <h3 className="font-heading font-bold text-2xl lg:text-3xl text-ink-dark leading-tight" data-id="element-1870" data-mp="b09evkfd1u3i">
            Use the framework through Noetivra
          </h3>
        </div>
        <div className="lg:col-span-7" data-id="element-1871" data-mp="3sf6g17oibt16">
          <p className="text-lg text-ink-dark leading-relaxed mb-4" data-id="element-1872" data-mp="19y0f3y1w2id">
            The Human Capability Edition is the shared HCF configuration behind
            the Education, Talent, Leadership and Community demos. In them you
            can complete a task, receive criterion-based review, follow a
            development activity and compare reassessment evidence.
          </p>
          <p className="text-ink-muted leading-relaxed mb-6" data-id="element-1873" data-mp="29il1n08i95od">
            SKP maintains the approved definitions, research and versioned
            knowledge supporting that work. Demo criteria are illustrative task
            rubrics, not validated CJI or NCJI instruments.
          </p>
          <div className="flex flex-wrap gap-x-8 gap-y-2" data-id="element-1874" data-mp="1via6hl05x4xe">
            <a href="/noetivra#human-capability-edition" className="inline-flex items-center gap-2 font-semibold text-navy hover:text-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-1875" data-mp="1vitpz65go1dj">
              Human Capability Edition
              <ArrowRight size={16} aria-hidden="true" data-id="element-1876" data-mp="1zj3xwoctd1v1" />
            </a>
            <a href={demoCenterPath} className="inline-flex items-center gap-2 font-semibold text-navy hover:text-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-1877" data-mp="3fxvnktikrv0n">
              Demo Center
              <ArrowRight size={16} aria-hidden="true" data-id="element-1878" data-mp="a5nqey75r18f" />
            </a>
          </div>
        </div>
      </motion.div>

      <FutureUses area="hcf" className="mt-12" data-id="element-1879" data-mp="f5a4f9ut8lia" />
    </section>;
}